import React from "react";
import Logo from "../../assets/logoRed.png";
import { Navbar,Button, Nav } from 'react-bootstrap';
import "./style.css";
import { Link} from "react-scroll";
import { UserContext } from "../../providers/UserProvider";
import { firestore } from "../../firebase";

import { makeStyles } from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import { auth } from "../../firebase";

const useStyles = makeStyles((theme) => ({
  toolbar: {
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  toolbarTitle: {
    flex: 1,
  },
  toolbarSecondary: {
    justifyContent: "space-between",
    overflowX: "auto",
  },
  toolbarLink: {
    padding: theme.spacing(1),
    flexShrink: 0,
  },
}));

export default function NavBar(props) {
  const classes = useStyles();
  const { sections, navBarDisconnect=false } = props;

  const user = React.useContext(UserContext);
  const [userData, setUserData] = React.useState("");
  const userRef = firestore.collection("usersData").doc(user.uid)
  React.useEffect(() => {
    userRef
      .get()
      .then((doc) => {
        if (doc.exists) {
          let data = doc.data();
          setUserData(data);
        } else {
          // doc.data() will be undefined in this case
          setUserData(null);
          console.log("No such document!");
        }
      })
      .catch(function (error) {
        setUserData(null);
        console.log("Error getting document:", error);
      });
  }, []);
  if (!userData) return <div></div>;


  return (
    <div>
    <Toolbar className={classes.toolbar}>
        {/* <Typography
          component="h2"
          variant="h5"
          color="inherit"
          align="center"
          noWrap
          className={classes.toolbarTitle}
        >
          {title}
        </Typography> */}
        {/* <Button variant="outlined" size="large">
          Sign in
        </Button>
        <Button variant="outlined" size="large">
          Sign up
        </Button> */}
      </Toolbar>
    
  <Navbar className="navbar" bg="light" expand="lg">
  
  <Navbar.Toggle aria-controls="basic-navbar-nav" />
  <Navbar.Collapse id="basic-navbar-nav">
    <Nav>
      <React.Fragment>
      <Toolbar
        component="nav"
        variant="dense"
        className={classes.toolbarSecondary}
      >
        {sections.map((section) =>
          section.title == "מי אנחנו" ? (
            <div class="dropdown">
              <Link
                activeClass="active"
                to="whoarewe"
                spy={true}
                smooth={true}
                offset={0}
                duration={500}
                className="dropbtn"
              >
                {section.title}
              </Link>
              <div class="dropdown-content">
                <Link
                  activeClass="active"
                  to="whoarewe"
                  spy={true}
                  smooth={true}
                  offset={0}
                  duration={500}
                >
                  למה אנחנו
                </Link>
                <Link
                  activeClass="active"
                  to="howitworks"
                  spy={true}
                  smooth={true}
                  offset={0}
                  duration={500}
                >
                איך זה עובד
                </Link>
                <Link
                  activeClass="active"
                  to="qa"
                  spy={true}
                  smooth={true}
                  offset={0}
                  duration={500}
                >
                  שאלות ותשובות
                </Link>
                <Link
                  activeClass="active"
                  to="packages"
                  spy={true}
                  smooth={true}
                  offset={0}
                  duration={500}
                >
                  חבילות
                </Link>
              </div>
            </div>
          ) : section.title == "צור קשר" ?(
              <Link
                  activeClass="active"
                  to="contactus"
                  spy={true}
                  smooth={true}
                  offset={0}
                  duration={500}
                  className="dropbtn"
                >
                  צור קשר
                </Link>
            )
            : section.title == "אח בוגר" ?(
            <div class="dropdown">
              <Link
                activeClass="active"
                to=""
                spy={true}
                smooth={true}
                offset={0}
                duration={500}
                className="dropbtn"
              >
                {section.title}
              </Link>
              <div class="dropdown-content">
                <Link
                  activeClass="active"
                  to=""
                  spy={true}
                  smooth={true}
                  offset={0}
                  duration={500}
                >
                  עזרה מעורך דין ותיק
                </Link>
                <Link
                  activeClass="active"
                  to=""
                  spy={true}
                  smooth={true}
                  offset={0}
                  duration={500}
                >
                  עזרה בכתיבת כתבי טענות
                </Link>
              </div>
            </div> 
            ) : section.title == "הפניות תיקים" ?(
            <div class="dropdown">
            <a href={section.url} className="dropbtn">{section.title}</a>
              <div class="dropdown-content">
                <a href={section.url} className="dropbtn">חיפוש תיקים</a>
                <a href="/PostLead" className="dropbtn">פרסם תיק</a>
                <a href="/SavedLeads" className="dropbtn">תיקים שמורים</a>
                <a href="/MyLeads" className="dropbtn">תיקים שפירסמתי</a>
              </div>
            </div> 
            ) : section.title == "פרופיל" ?(
            <div class="dropdown">
            <a href={section.url} className="dropbtn" style={{padding: 'unset'}}><img className="navbar-image" src={userData.userImageDownloadUrl || 'https://source.unsplash.com/dLij9K4ObYY/900x900/'}/></a>
              <div class="dropdown-content">
                <a href={section.url} className="dropbtn">פרופיל</a>
                <a href="/ProfileUpdate" className="dropbtn">הגדרות</a>
                <a href="/UserInbox" className="dropbtn">{userData.numberOfUnreadInboxes? <span className="redCircle">{userData.numberOfUnreadInboxes}</span> : null} תיבת דואר</a>
                <a className="dropbtn"><Button variant="danger" onClick={() => { auth.signOut(); window.location = "/MainPage";}}>התנתק</Button></a>
              </div>
            </div> 
            )
            : (
            <a href={section.url} className="dropbtn">{section.title}</a>
          )
          
        )}
        <Button href = '/SearchLead' size="large">
          <img
            src={Logo}
            className="img-responsive"
            style={{ width: "30px", marginTop: "-5px" }}
            alt="Logo"
          />
        </Button>
      </Toolbar>
    </React.Fragment>
    </Nav>
  </Navbar.Collapse>
  
</Navbar>
</div>
  );
}
